import React, {useEffect, useState} from 'react';
import Translate, {t} from '../../../../../../components/Translate';
import './Channels.css';
import {
    addTelegramBot,
    addWebexBot,
    addWhatsAppBot,
    attachInstagramPageToCompany,
    attachMessengerPageToCompany,
    deleteTelegramBot,
    deleteWebexBot,
    deleteWhatsAppBot,
    getAllPages,
    getInstagramAllPages,
    getInstagramBot,
    getMessengerBot,
    getTelegramBot,
    getWebexBot,
    getWhatsAppBot,
    handleFacebookLogin,
    handleFacebookLogout,
} from '../../../../../../services/integrations/api';
import MessengerLogo from '../../../../../../assets/images/MessengerLogo.png'
import TelegramLogo from '../../../../../../assets/images/TelegramLogo.png'
import InstagramLogo from '../../../../../../assets/images/InstagramLogo.png'
import WebexLogo from '../../../../../../assets/images/Webex.png'
import WhatsAppLogo from 'assets/images/WhatsAppLogo.png'
import BotIcon from 'assets/images/no-image.png'
import ChatIcon from 'assets/images/chat.png'
import MobileChatIcon from 'assets/images/mobile-webchat.png'
import config from 'config';
import BlueButton from "../../../../../../components-new/buttons/BlueButton";
import IntegrationCode from "../webchat-conf/IntegrationCode";
import MobileIntegrationCode from "../webchat-conf/MobileIntegrationCode";
import FacebookLoginButton from "../../../../../../components-new/FacebookLoginButton";
import {silverInfoStyles, tabButtonStyles} from "../../../../../../utils/General";
import RedButton from "../../../../../../components-new/buttons/RedButton";
import LoadingComponent from "../../../../../../assets/LoadingComponent";

const webback = config.WEBBACK_HOST;

function Channels({tariff, client, addNotification, user}) {

    const {messengers} = tariff;

    const [telegramBotToken, setTelegramBotToken] = useState("");
    const [telegramBot, setTelegramBot] = useState();

    const [webexBotToken, setWebexBotToken] = useState("");
    const [webexBot, setWebexBot] = useState();

    const [messengerBot, setMessengerBot] = useState();
    const [messengerPagesData, setMessengerPagesData] = useState();

    const [instagramBot, setInstagramBot] = useState();
    const [instagramPagesData, setInstagramPagesData] = useState();

    const [whatsAppAccessToken, setWhatsAppAccessToken] = useState("");
    const [whatsAppPhoneNumberId, setWhatsAppPhoneNumberId] = useState("");
    const [whatsAppBot, setWhatsAppBot] = useState();

    const [activeTab, setActiveTab] = useState('webchat');

    const [isFacebookLoading, setIsFacebookLoading] = useState(false);


    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            const telegramData = await getTelegramBot(client.id);
            if (telegramData !== "Not found") if (isMounted) setTelegramBot(telegramData);

            const webexData = await getWebexBot(client.id);
            if (webexData !== "Not found") if (isMounted) setWebexBot(webexData);

            const messengerData = await getMessengerBot(client.id);
            if (messengerData !== "Not found") if (isMounted) setMessengerBot(messengerData);
            const fbPages = await getAllPages(client.id);
            if (fbPages !== "Not found") if (isMounted) setMessengerPagesData(fbPages);

            const instagramData = await getInstagramBot(client.id);
            if (instagramData !== "Not found") if (isMounted) setInstagramBot(instagramData);
            const instaPages = await getInstagramAllPages(client.id);
            if (instaPages !== "Not found") if (isMounted) setInstagramPagesData(instaPages);

            const whatsAppData = await getWhatsAppBot(client.id);
            if (whatsAppData !== "Not found") if (isMounted) setWhatsAppBot(whatsAppData);
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [client.id]);


    // telegram
    const handleTelegramBotSave = () => {
        addTelegramBot(telegramBotToken, client.id).then(data => {
            updateTelegramBot();
            addNotification("added", config.notificationLevels.success)
        }).catch(() => {
            addNotification("somethingWentWrong", config.notificationLevels.error)
        });
    };

    const updateTelegramBot = () => {
        getTelegramBot(client.id).then(data => {
            if (data === "Not found") {
                return;
            }
            setTelegramBot(data);
        });
    };

    const onTelegramInputChange = (event) => {
        setTelegramBotToken(event.target.value);
    };

    const handleDeleteTelegramBot = () => {
        const telegramBotDiv = document.querySelector('.telegram-bot-div');
        telegramBotDiv.classList.add('deleting');
        setTimeout(() => {
            deleteTelegramBot(client.id).then(data => {
                setTelegramBot(undefined);
                addNotification("deleted", config.notificationLevels.info)
            });
        }, 300);
    };
    //

    // webex
    const handleWebexBotSave = () => {
        addWebexBot(webexBotToken, client.id).then(data => {
            updateWebexBot();
            addNotification("added", config.notificationLevels.success)
        }).catch(() => {
            addNotification("somethingWentWrong", config.notificationLevels.error)
        });
    };

    const updateWebexBot = () => {
        getWebexBot(client.id).then(data => {
            if (data === "Not found") {
                return;
            }
            setWebexBot(data);
        });
    };

    const onWebexInputChange = (event) => {
        setWebexBotToken(event.target.value);
    };

    const handleDeleteWebexBot = () => {
        const webexBotDiv = document.querySelector('.webex-bot-div');
        webexBotDiv.classList.add('deleting');
        setTimeout(() => {
            deleteWebexBot(client.id).then(data => {
                setWebexBot(undefined);
                addNotification("deleted", config.notificationLevels.info)
            });
        }, 300);
    }
    //

    // facebook
    const handleFacebookLoginClick = (tokenData, companyId) => {
        setIsFacebookLoading(true);
        handleFacebookLogin(tokenData, companyId)
            .then(data => {
                setMessengerPagesData(data.messengerPages);
                setInstagramPagesData(data.instagramPages);
                addNotification("successful", config.notificationLevels.success);
            })
            .catch((error) => {
                if (
                    (error && error.response && error.response.data === "No pages found for this user") ||
                    (error && error.message === "No pages found for this user")
                ) {
                    addNotification("facebookLoginError1", config.notificationLevels.warning);
                } else {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                }
            })
            .finally(() => setIsFacebookLoading(false));
    };

    const handleFacebookLogoutClick = ({
                                           clientId,
                                           setMessengerPagesData,
                                           setMessengerBot,
                                           setInstagramBot,
                                           setInstagramPagesData,
                                           addNotification,
                                       }) => {
        return async function () {
            setIsFacebookLoading(true);
            try {
                await handleFacebookLogout(clientId);
                setMessengerPagesData(null);
                setMessengerBot(null);
                setInstagramBot(null);
                setInstagramPagesData(null);
                addNotification("deleted", config.notificationLevels.info);
            } catch (err) {
                addNotification("somethingWentWrong", config.notificationLevels.error);
            } finally {
                setIsFacebookLoading(false);
            }
        };
    };
    //

    // messenger
    const handleMessengerPageChange = ({
                                           clientId,
                                           messengerPagesData,
                                           setMessengerBot,
                                           addNotification,
                                       }) => {
        return async function (e) {
            const selectedPageId = e.target.value;

            try {
                await attachMessengerPageToCompany(clientId, selectedPageId);
                addNotification("successful", config.notificationLevels.success);

                if (selectedPageId === '') {
                    setMessengerBot(null);
                } else {
                    const selectedPage = messengerPagesData.find(page => page.pageId === selectedPageId);
                    setMessengerBot(selectedPage || null);
                }
            } catch (err) {
                if (err.response.data) {
                    const errorMessage = err.response.data;

                    if (errorMessage === 'Already attached to another bot') {
                        addNotification("thisPageAttachedToAnotherBot", config.notificationLevels.error);
                    } else if (errorMessage === 'Page not found') {
                        addNotification("pageNotFound", config.notificationLevels.error);
                    } else {
                        addNotification(errorMessage, config.notificationLevels.error);
                    }
                } else {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                }
            }
        };
    }
    //

    // instagram
    const handleInstagramPageChange = ({
                                           clientId,
                                           instagramPagesData,
                                           setInstagramBot,
                                           addNotification,
                                       }) => {
        return async function (e) {
            const selectedPageId = e.target.value;

            try {
                await attachInstagramPageToCompany(clientId, selectedPageId);
                addNotification("successful", config.notificationLevels.success);

                if (selectedPageId === '') {
                    setInstagramBot(null);
                } else {
                    const selectedPage = instagramPagesData.find(page => page.id === selectedPageId);
                    setInstagramBot(selectedPage || null);
                }
            } catch (err) {
                if (err.response.data) {
                    const errorMessage = err.response.data;

                    if (errorMessage === 'Already attached to another bot') {
                        addNotification("thisPageAttachedToAnotherBot", config.notificationLevels.error);
                    } else if (errorMessage === 'Page not found') {
                        addNotification("pageNotFound", config.notificationLevels.error);
                    } else {
                        addNotification(errorMessage, config.notificationLevels.error);
                    }
                } else {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                }
            }
        };
    }
    //

    // whatsapp
    const handleWhatsAppBotSave = () => {
        const whatsAppBotData = {
            accessToken: whatsAppAccessToken,
            phoneNumberId: whatsAppPhoneNumberId
        };
        addWhatsAppBot(whatsAppBotData, client.id).then(() => {
            setWhatsAppBot(whatsAppBotData)
        });
    };

    const onWhatsAppInputChange = (event) => {
        const {name, value} = event.target;

        if (name === "accessToken") {
            setWhatsAppAccessToken(value);
        } else if (name === "phoneNumberId") {
            setWhatsAppPhoneNumberId(value);
        }
    };

    const handleDeleteWhatsAppBot = () => {
        const whatsAppBotDiv = document.querySelector('.whatsapp-bot-div');
        whatsAppBotDiv.classList.add('deleting');
        setTimeout(() => {
            deleteWhatsAppBot(client.id).then(() => {
                setWhatsAppBot(undefined);
            });
        }, 300);
    };
    //

    return (
        <div className={'channels-parent-div'}>

            <div style={tabButtonStyles.tabButtons}>
                {messengers.includes(config.platformsMap.webchat) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'webchat', 'rgb(235 238 249)')}
                            onClick={() => setActiveTab('webchat')}>
                        <img src={ChatIcon} height={'30px'} width={'30px'}/>
                    </button>
                )}

                {messengers.includes(config.platformsMap.telegram) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'telegram', 'rgb(235 238 249)')}
                            onClick={() => setActiveTab('telegram')}>
                        <img src={TelegramLogo} height={'30px'} width={'30px'}/>
                    </button>
                )}

                {messengers.includes(config.platformsMap.webex) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'webex', 'rgb(235 238 249)')}
                            onClick={() => setActiveTab('webex')}>
                        <img src={WebexLogo} height={'30px'} width={'30px'}/>
                    </button>
                )}

                {messengers.includes(config.platformsMap.messenger) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'messenger', 'rgb(235 238 249)')}
                            onClick={() => setActiveTab('messenger')}>
                        <img src={MessengerLogo} height={'30px'} width={'30px'}/>
                    </button>
                )}

                {messengers.includes(config.platformsMap.instagram) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'instagram', 'rgb(235 238 249)')}
                            onClick={() => setActiveTab('instagram')}>
                        <img src={InstagramLogo} height={'30px'} width={'30px'}/>
                    </button>
                )}

                {messengers.includes(config.platformsMap.whatsapp) && (
                    <button disabled={true} style={{...tabButtonStyles.tabButton(activeTab === 'whatsapp', 'rgb(235 238 249)'), opacity: '0.5'}}
                            onClick={() => setActiveTab('whatsapp')}>
                        <img src={WhatsAppLogo} height={'30px'} width={'30px'}/>
                    </button>
                )}

            </div>

            {messengers.includes(config.platformsMap.webchat) && activeTab === 'webchat' && (
                <div className="channel bg-white" style={{padding: '20px'}}>
                    <div className="bg-white">
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '20px'
                        }}>
                            <img src={ChatIcon} height={'50px'} style={{marginRight: '15px'}}/>
                            <h2>WebChat</h2>
                        </div>
                        <IntegrationCode client={client}
                                         commonStyles={{bottomMargin: '10px'}}/>
                    </div>
                </div>
            )}

            {messengers.includes(config.platformsMap.webchat) && activeTab === 'webchat' && (
                <div className="channel bg-white" style={{padding: '20px'}}>
                    <div className="bg-white">
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '20px'
                        }}>
                            <img src={MobileChatIcon} height={'50px'}
                                 style={{marginRight: '15px'}}/>
                            <h2>WebChat (Mobile)</h2>
                        </div>
                        <MobileIntegrationCode client={client}
                                               commonStyles={{bottomMargin: '10px'}}/>
                    </div>
                </div>
            )}

            {messengers.includes(config.platformsMap.telegram) && activeTab === 'telegram' && (
                <div className="channel bg-white" style={{padding: '20px'}}>
                    <div style={{display: 'flex', gap: '20px', alignItems: 'center'}}>
                        <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <img src={TelegramLogo} height={'50px'}
                                     style={{marginRight: '15px'}}/>
                                <h2>
                                    Telegram
                                </h2>
                            </div>

                            <div
                                className="configuration-expl-title"
                                style={{
                                    ...silverInfoStyles.info,
                                    marginLeft: '0px',
                                    marginBottom: '20px',
                                    textAlign: 'center'
                                }}
                            >
                                <p><Translate text={'telegramSetup1'}/></p>
                                <p><Translate text={'telegramSetup2'}/></p>
                            </div>


                        </div>
                    </div>
                    <div className="telegram-bot-parent-div">
                        {telegramBot &&
                            <div className="telegram-bot-div">
                                <div className="telegram-bot-image-div">
                                    {telegramBot.profile_image_url !== null &&
                                        <img className="telegram-bot-profile-img" width={40} height={40}
                                             src={telegramBot.profile_image_url}/>
                                    }
                                    {telegramBot.profile_image_url === null &&
                                        <img className="telegram-bot-profile-img" width={40} height={40}
                                             src={BotIcon}/>
                                    }
                                </div>
                                <span>{telegramBot.name}</span>
                                <span onClick={handleDeleteTelegramBot}
                                      className="telegram-bot-delete-button">&times;</span>
                            </div>
                        }
                    </div>
                    {!telegramBot && (
                        <React.Fragment>
                            <input
                                disabled={!!telegramBot}
                                style={telegramBot ? {backgroundColor: 'rgb(217 217 217)'} : {backgroundColor: 'rgb(221, 228, 246)'}}
                                type="text"
                                name="botToken"
                                className={`inputChannel`}
                                placeholder='Bot Token'
                                value={telegramBotToken}
                                onChange={onTelegramInputChange}
                                autoComplete={"off"}
                            />
                            <div>
                                <BlueButton
                                    styles={{marginTop:'20px'}}
                                    disabled={!!telegramBot}
                                    onClick={handleTelegramBotSave}
                                    width={'135px'}
                                    children={<Translate text={'save'}/>}
                                />
                            </div>
                        </React.Fragment>
                    )}
                </div>
            )}

            {messengers.includes(config.platformsMap.webex) && activeTab === 'webex' && (
                <div className="channel bg-white" style={{padding: '20px'}}>

                    <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <img src={WebexLogo} height={'50px'} style={{marginRight: '15px'}}/>
                            <h2>Webex</h2>
                        </div>

                        <div
                            className="configuration-expl-title"
                            style={{
                                ...silverInfoStyles.info,
                                marginLeft: '0px',
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}
                        >
                            <p><Translate text={'webexSetup1'}/></p>
                            <p><Translate text={'webexSetup2'}/></p>
                            <p><Translate text={'webexSetup3'}/></p>
                        </div>
                    </div>

                    <div className="webex-bot-parent-div">
                        {webexBot &&
                            <div className="webex-bot-div">
                                <div className="webex-bot-image-div">
                                    {webexBot.profile_image_url !== null &&
                                        <img className="webex-bot-profile-img" width={40} height={40}
                                             src={webexBot.profile_image_url}/>
                                    }
                                    {webexBot.profile_image_url === null &&
                                        <img className="webex-bot-profile-img" width={40} height={40}
                                             src={BotIcon}/>
                                    }
                                </div>
                                <span>{webexBot.name}</span>
                                <span onClick={handleDeleteWebexBot}
                                      className="webex-bot-delete-button">&times;</span>
                            </div>
                        }
                    </div>

                    {!webexBot && (
                        <React.Fragment>
                            <input
                                disabled={!!webexBot}
                                style={webexBot ? {backgroundColor: 'rgb(217 217 217)'} : {backgroundColor: 'rgb(221, 228, 246)'}}
                                type="text"
                                name="botToken"
                                className={`inputChannel`}
                                placeholder='Bot Token'
                                value={webexBotToken}
                                onChange={onWebexInputChange}
                                autoComplete={"off"}
                            />
                            <div>
                                <BlueButton
                                    styles={{marginTop:'20px'}}
                                    disabled={!!webexBot}
                                    onClick={handleWebexBotSave}
                                    width={'135px'}
                                    children={<Translate text={'save'}/>}
                                />
                            </div>
                        </React.Fragment>
                    )}
                </div>
            )}

            {messengers.includes(config.platformsMap.messenger) && activeTab === 'messenger' && (
                <div className="channel bg-white rounded-lg shadow p-6">
                    <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <img src={MessengerLogo} height={'40px'} style={{marginRight: '15px'}}/>
                            <h2 style={{fontSize: '24px'}}>Messenger</h2>
                        </div>

                        <div
                            className="configuration-expl-title"
                            style={{
                                ...silverInfoStyles.info,
                                marginLeft: '0px',
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}
                        >
                            <p><Translate text={'messengerInstagramSetup'}/></p>
                        </div>

                    </div>

                    {messengerPagesData ? (
                        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                            {messengerBot && (
                                <div
                                    style={{
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        padding: '15px 20px',
                                        marginBottom: '20px',
                                        backgroundColor: '#f1f5f9',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                    }}
                                >
                                    <h4 style={{marginBottom: '5px', color: '#333'}}>
                                        <Translate text="selectedPage"/>:
                                    </h4>
                                    <p style={{
                                        margin: 0,
                                        fontWeight: 'bold',
                                        fontSize: '16px'
                                    }}>{messengerBot.pageName}</p>
                                </div>
                            )}

                            <div style={{maxWidth: '400px', marginBottom: '25px'}}>
                                <label htmlFor="messenger-page-select"
                                       style={{fontWeight: '600', marginBottom: '10px', display: 'block'}}>
                                    <Translate text="selectPage"/>
                                </label>
                                <select
                                    id="messenger-page-select"
                                    className="form-control"
                                    style={{
                                        padding: '10px 12px',
                                        borderRadius: '6px',
                                        border: '1px solid #ccc',
                                        fontSize: '15px',
                                        backgroundColor: '#fff',
                                        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
                                    }}
                                    value={(messengerBot && messengerBot.pageId) || ''}
                                    onChange={handleMessengerPageChange({
                                        clientId: client.id,
                                        messengerPagesData,
                                        setMessengerBot,
                                        addNotification,
                                    })}
                                >
                                    <option value="">{t({text: 'detachPage', user})}</option>
                                    {messengerPagesData.map((page) => (
                                        <option key={page.pageId} value={page.pageId}>
                                            {page.pageName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {isFacebookLoading && (
                                <LoadingComponent styles/>
                            )}
                            {!isFacebookLoading && (
                                <RedButton
                                    width="300px"
                                    style={{
                                        marginTop: '10px',
                                    }}
                                    onClick={handleFacebookLogoutClick({
                                        clientId: client.id,
                                        setMessengerPagesData,
                                        setMessengerBot,
                                        setInstagramBot,
                                        setInstagramPagesData,
                                        addNotification,
                                    })}
                                >
                                    <Translate text="logoutFacebookAccount"/>
                                </RedButton>
                            )}
                        </div>
                    ) : (
                        <React.Fragment>
                            {isFacebookLoading && (
                                <LoadingComponent/>
                            )}
                            {!isFacebookLoading && (
                                <FacebookLoginButton handleFacebookLogin={handleFacebookLoginClick} client={client}/>
                            )}
                        </React.Fragment>

                    )}
                </div>
            )}

            {messengers.includes(config.platformsMap.instagram) && activeTab === 'instagram' && (
                <div className="channel bg-white rounded-lg shadow p-6">
                    <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <img src={InstagramLogo} height={'40px'} style={{marginRight: '15px'}}/>
                            <h2 style={{fontSize: '24px'}}>Instagram</h2>
                        </div>

                        <div
                            className="configuration-expl-title"
                            style={{
                                ...silverInfoStyles.info,
                                marginLeft: '0px',
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}
                        >
                            <p><Translate text={'messengerInstagramSetup'}/></p>
                        </div>

                    </div>

                    {instagramPagesData ? (
                        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                            {instagramBot && (
                                <div
                                    style={{
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        padding: '15px 20px',
                                        marginBottom: '20px',
                                        backgroundColor: '#f1f5f9',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                    }}
                                >
                                    <h4 style={{marginBottom: '5px', color: '#333'}}>
                                        <Translate text="selectedPage"/>:
                                    </h4>
                                    <p style={{
                                        margin: 0,
                                        fontWeight: 'bold',
                                        fontSize: '16px'
                                    }}>{instagramBot.username}</p>
                                </div>
                            )}

                            <div style={{maxWidth: '400px', marginBottom: '25px'}}>
                                <label htmlFor="messenger-page-select"
                                       style={{fontWeight: '600', marginBottom: '10px', display: 'block'}}>
                                    <Translate text="selectPage"/>
                                </label>
                                <select
                                    id="messenger-page-select"
                                    className="form-control"
                                    style={{
                                        padding: '10px 12px',
                                        borderRadius: '6px',
                                        border: '1px solid #ccc',
                                        fontSize: '15px',
                                        backgroundColor: '#fff',
                                        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
                                    }}
                                    value={(instagramBot && instagramBot.id) || ''}
                                    onChange={handleInstagramPageChange({
                                        clientId: client.id,
                                        instagramPagesData,
                                        setInstagramBot,
                                        addNotification
                                    })}
                                >
                                    <option value="">{t({text: 'detachPage', user})}</option>
                                    {instagramPagesData.map((page) => (
                                        <option key={page.id} value={page.id}>
                                            {page.username}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {isFacebookLoading && (
                                <LoadingComponent/>
                            )}
                            {!isFacebookLoading && (
                                <RedButton
                                    width="300px"
                                    style={{
                                        marginTop: '10px',
                                    }}
                                    onClick={handleFacebookLogoutClick({
                                        clientId: client.id,
                                        setMessengerPagesData,
                                        setMessengerBot,
                                        setInstagramBot,
                                        setInstagramPagesData,
                                        addNotification,
                                    })}
                                >
                                    <Translate text="logoutFacebookAccount"/>
                                </RedButton>
                            )}
                        </div>
                    ) : (
                        <React.Fragment>
                            {isFacebookLoading && (
                                <LoadingComponent/>
                            )}
                            {!isFacebookLoading && (
                                <FacebookLoginButton handleFacebookLogin={handleFacebookLoginClick} client={client}/>
                            )}
                        </React.Fragment>
                    )}
                </div>
            )}

            {messengers.includes(config.platformsMap.whatsapp) && activeTab === 'whatsapp' && (
                <div className="channel bg-white" style={{padding: '20px'}}>
                    <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <img src={WhatsAppLogo} height={'50px'}
                                 style={{marginRight: '15px'}}/>
                            <h2>Whatsapp</h2>
                        </div>
                    </div>

                    {whatsAppBot && (
                        <div className="whatsapp-bot-div">
                            <span>Phone Number ID: {whatsAppBot.phoneNumberId}</span>
                            <span onClick={handleDeleteWhatsAppBot}
                                  className="whatsapp-bot-delete-button">&times;</span>
                        </div>
                    )}

                    {whatsAppBot && (
                        <div>Webhook: &ensp;
                            <span
                                style={{userSelect: 'all'}}>{webback}/whatsapp/message/handle/{client.id}/{whatsAppBot.phoneNumberId}</span>
                            <br/>
                            <br/>
                        </div>
                    )}

                    <input
                        value={whatsAppPhoneNumberId}
                        type="text"
                        name="phoneNumberId"
                        className="inputChannel"
                        placeholder="Phone Number ID"
                        onChange={onWhatsAppInputChange}
                        disabled={!!whatsAppBot}
                        style={whatsAppBot ? {backgroundColor: 'rgb(217 217 217)'} : {backgroundColor: 'rgb(221, 228, 246)'}}
                    />
                    <input
                        value={whatsAppAccessToken}
                        type="text"
                        name="accessToken"
                        className="inputChannel"
                        placeholder="Access Token"
                        onChange={onWhatsAppInputChange}
                        disabled={!!whatsAppBot}
                        style={whatsAppBot ? {backgroundColor: 'rgb(217 217 217)'} : {backgroundColor: 'rgb(221, 228, 246)'}}
                    />
                    <div>
                        <BlueButton
                            styles={{marginTop:'20px'}}
                            disabled={!!whatsAppBot}
                            onClick={handleWhatsAppBotSave}
                            width={'135px'}
                            children={<Translate text={'save'}/>}
                        />
                    </div>
                </div>
            )}

        </div>
    );
}

export default Channels;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/Channels.jsx